import { render, staticRenderFns } from "./GovWorld.vue?vue&type=template&id=00fa2c2e&scoped=true"
import script from "./GovWorld.vue?vue&type=script&lang=js"
export * from "./GovWorld.vue?vue&type=script&lang=js"
import style0 from "./GovWorld.vue?vue&type=style&index=0&id=00fa2c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa2c2e",
  null
  
)

export default component.exports